export default {
      id: "cross-sm-usage",
      viewBox: "0 0 10 10",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#cross-sm",
      toString: function () {
        return this.url;
      }
    }